<tt-page>
    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
    <!-- <tt-grid *ngIf="!!gridChargeTest" class="flex-1" [(ttOptions)]="gridChargeTest"></tt-grid> -->
</tt-page>
